import { useCallback } from 'react'
import useAuth from './useAuth'

/**
 * Hook para gerenciar persistência de filtros no localStorage
 * Separa os dados por pluginSpaceId para evitar conflitos entre lojas
 */
export const useFilterStorage = (pageKey: string) => {
  const { loginInfo } = useAuth()

  // Gera chave única para cada página e pluginSpace
  const getStorageKey = useCallback(() => {
    return `filtros_${pageKey}_${loginInfo.pluginspaceId}`
  }, [pageKey, loginInfo.pluginspaceId])

  // Salva filtros no localStorage
  const saveFilters = useCallback((filters: any) => {
    try {
      localStorage.setItem(getStorageKey(), JSON.stringify(filters))
    } catch (error) {
      console.error('Erro ao salvar filtros:', error)
    }
  }, [getStorageKey])

  // Carrega filtros do localStorage
  const loadFilters = useCallback(() => {
    try {
      const saved = localStorage.getItem(getStorageKey())
      if (saved) {
        return JSON.parse(saved)
      }
    } catch (error) {
      console.error('Erro ao carregar filtros:', error)
    }
    return null
  }, [getStorageKey])

  // Remove filtros do localStorage
  const clearFilters = useCallback(() => {
    try {
      localStorage.removeItem(getStorageKey())
    } catch (error) {
      console.error('Erro ao limpar filtros:', error)
    }
  }, [getStorageKey])

  return {
    saveFilters,
    loadFilters,
    clearFilters,
    storageKey: getStorageKey()
  }
}
